/*

This file is used to generate a 3d building based on the floor plan

*/
import { server } from '../../engine/server'
import THREE from 'particlespace-graphics-engine'
import THREEx from 'particlespace-graphics-engine-extensions'
import {browserHistory} from 'react-router';

import {floorPlanRenderer} from '../controllers/FloorPlanRenderer';
import {activeSensorsManager} from '../../controllers/ActiveSensorsManager';
import {activeLevelTempetureReadingsManager} from '../../controllers/ActiveLevelTempetureReadingsManager';
import {colorConverter} from '../../../helpers/General/ColorConverter.js';

var buildingObject = Class.create({
  	initialize: function() {
		this.buildingData = null;
		this.height = 0;
		this.width = 0;
		this.offsetY = 0;
		this.activeSensors = [];
		this.activeWindowTimeout = [];
		this.activeSensorUuid = [];
	  },
	clearWindowTimeouts: function() {
		this.activeWindowTimeout.forEach(timeout => {
			window.clearTimeout(timeout);
		});
		this.activeSensors = [];
		this.activeSensorUuid = [];
		this.activeWindowTimeout = [];
	},
	setUpWindowSize: function() {
		var computedHeight = window.innerHeight;//(jQuery("#main").height() - jQuery("#main nav").height());
		var shaveOff = computedHeight * .3;
		computedHeight = computedHeight - shaveOff;
		if(computedHeight > 550) {
			computedHeight = 550;
		}

		this.height = computedHeight;
		this.width = jQuery('#building-overview').width();//jQuery("#main").width();
	},
	onDocumentMouseMove: function(e) {
		e.preventDefault();
		this.mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
		this.mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
	},
	onWindowResize: function() {
		this.setUpWindowSize();
		this.camera.aspect = this.width / this.height;
		this.camera.updateProjectionMatrix();
		this.context.state.renderer.setSize(this.width, this.height);
		this.context.state.renderer.render( this.scene, this.camera );
	},
	onWindowScroll: function(e) {
		this.offsetY = e.srcElement.scrollTop;
		this.domEvents.addScrollOffset(this.offsetY);
	},
  	// #  The main use of this function is to pass a id to store our mini floor plan
  	createMini3DBuildingModel: function(context,floor_plan_type,total_levels, level_states) {
  		// #  Associate our id with our canvas to rendering
		var canvasID = context.state.canvasID;
  		// #  Setup element sizes
		var width = document.getElementById(canvasID).clientWidth;
		var height = document.getElementById(canvasID).clientHeight - 10;
  		// #  Setup our scene in which we will draw our canvas too.
		var scene = new THREE.Scene();
		// #  Setup canvas camera
		var camera = null;
		this.context = context;
		// #  Call building creation
		var buildingsObj = this.buildMiniBuildingWireFrame(floor_plan_type, total_levels, canvasID, level_states);
		var buildings = null;
		if(buildingsObj == null) {
			return;
		} else {
			buildings = buildingsObj['scene'];
			camera = buildingsObj['camera'];
			scene = buildings;
		}
		// # Lights
		var ambientLight = new THREE.AmbientLight( 0x606060 );
		// #  Add to scene
		scene.add( ambientLight );
		// #  Setup directional lighting - use as sun.
		var directionalLight = new THREE.DirectionalLight( 0xffffff );
		directionalLight.position.x = -0.3146332814932844;//Math.random() - 0.5;
		directionalLight.position.y = 0.22805864947094354;//Math.random() - 0.5;
		directionalLight.position.z = -0.921409328462794;//Math.random() - 0.5;
		directionalLight.position.normalize();
		// #  Add to scene
		scene.add( directionalLight );
		var directionalLight = new THREE.DirectionalLight( 0x808080 );
		directionalLight.position.x = -0.04955394517284462;//Math.random() - 0.5;
		directionalLight.position.y = 0.6221458805093545;//Math.random() - 0.5;
		directionalLight.position.z = 0.7813314980743108;//Math.random() - 0.5;
		directionalLight.position.normalize();
		// #  Add to scene
		scene.add( directionalLight );
		// #  Setup our color for the background
		context.state.renderer.setClearColor( 0xFBFBFB );//0xf0f0f0
		// #  We need to dynamically set our width
		context.state.renderer.setSize( width, height );
		context.state.renderer.render( scene, camera );
		context.setState({
            updateCanvas: true
		});
		this.context = context;
		this.camera = camera;
		this.scene = scene;
		this.renderer = context.state.renderer;
		activeSensorsManager.displayActiveSensorColorChange();
		// document.addEventListener('mousemove', onDocumentMouseMove, false);
		// window.addEventListener('resize', onWindowResize, false);
		// #  Attach our renderer to our container
		//container.appendChild(renderer.domElement);
	},
  	buildMiniBuildingWireFrame: function(floor_plan_type,total_levels,canvasID, level_states) {
  		// # return zoom out distance
		  var zoomOutLimit = 0;
		  var self = this;
  		// #  Setup our size and step
		var total_levels = parseInt(total_levels);
		// #  Setup THREE.shape object
		var shape = null;
		// #  Setup our scene in which we will draw our canvas too.
		var scene = new THREE.Scene();
		// #  Setup element sizes
		var width = document.getElementById(canvasID).clientWidth;
		var height = document.getElementById(canvasID).clientHeight - 10;
		// #  Setup camera
		var camera = new THREE.PerspectiveCamera(40, width / height, 1, 10000);
		// #  Setup response
		var response = [];
  		// #  Determine our grid type and process accordingly
		if(floor_plan_type == "TR-L"){
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(0, -700, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());
			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();
				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( buildingLength, buildingWidth );
				buildingShape.lineTo( buildingLength, 0 );
				// #  Start the bottom section
				buildingShape.lineTo( buildingMiddlePoint, 0);
				buildingShape.lineTo( buildingMiddlePoint, -buildingWidth );
				buildingShape.lineTo( 0, -buildingWidth );
				buildingShape.lineTo( 0, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( -70, -300, levelY );
				scene.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: color, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( -70, -300, levelY );
				// #  Add to current scene
				scene.add(buildingMesh);
				/*var wireframeTexture = new THREE.MeshBasicMaterial( { color: 0xe8e8e8, wireframe: true, transparent: true,opacity: 0.6 } ); 
				//var mesh = new THREE.Mesh( geometry, new THREE.MeshPhongMaterial({color: 0xe8e8e8 ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6}) );	
				var mesh = new THREE.Mesh(geometry, wireframeTexture);
				mesh.position.set( 0, -300, levelY );
				scene.add(mesh);*/

				/*var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var geometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				var mesh = new THREE.Mesh( geometry, new THREE.MeshPhongMaterial({color: 0xe8e8e8 ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6}) );	
				mesh.position.set( 0, -300, levelY );
				scene.add(mesh);*/
			}

			shape = buildingShape;
		}
		else if(floor_plan_type == "BR-L"){
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(0, -700, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());
			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( buildingLength, 0 );
				buildingShape.lineTo( buildingLength, buildingWidth );
				buildingShape.lineTo( buildingMiddlePoint, buildingWidth );
				// #  Start the top section
				buildingShape.lineTo( buildingMiddlePoint, 80);
				buildingShape.lineTo( 0, 80 );
				buildingShape.lineTo( 0, 0 );

				/*var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var geometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				var mesh = new THREE.Mesh( geometry, new THREE.MeshPhongMaterial({color: 0xe8e8e8 ,wireframe: false, overdraw: true,transparent: true, opacity: 0.6}) );	
				mesh.position.set( 0, -300, levelY );
				scene.add(mesh);*/

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( -70, -300, levelY );
				scene.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: color, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( -70, -300, levelY );
				// #  Add to current scene
				scene.add(buildingMesh);
			}

			
			shape = buildingShape;
		}
		if(floor_plan_type == "TL-L"){
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(0, -700, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());
			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, -buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint, -buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint, 0 );
				// #  Start the bottom section
				buildingShape.lineTo( -buildingLength, 0);
				buildingShape.lineTo( -buildingLength, buildingWidth );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( 0, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( 70, -300, levelY );
				scene.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: color, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( 70, -300, levelY );
				// #  Add to current scene
				scene.add(buildingMesh);
			}
			shape = buildingShape;
		}
		else if(floor_plan_type == "BL-L"){
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(0, -700, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());
			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint, buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint, 0 );
				// #  Start the bottom section
				buildingShape.lineTo( -buildingLength, 0);
				buildingShape.lineTo( -buildingLength, -buildingWidth );
				buildingShape.lineTo( 0, -buildingWidth );
				buildingShape.lineTo( 0, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( 70, -300, levelY );
				scene.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: color, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( 70, -300, levelY );
				// #  Add to current scene
				scene.add(buildingMesh);
			}

			shape = buildingShape;
		}
		else if(floor_plan_type == "Square"){
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(0, -700, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());
			var buildingLength = 120, buildingWidth = 80, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( buildingLength, buildingWidth );
				buildingShape.lineTo( buildingLength, 0 );

				/*var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var geometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				var mesh = new THREE.Mesh( geometry, new THREE.MeshPhongMaterial({color: 0xe8e8e8 ,wireframe: false, overdraw: true,transparent: true, opacity: 0.6}) );	
				mesh.position.set( 0, -300, levelY );
				scene.add(mesh);*/

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( -60, -300, levelY );
				scene.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: color, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( -60, -300, levelY );
				// #  Add to current scene
				scene.add(buildingMesh);
			}

			shape = buildingShape;
		}
		else if(floor_plan_type == "Rectangle"){
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(0, -700, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());
			var buildingLength = 180, buildingWidth = 50, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( buildingLength, buildingWidth );
				buildingShape.lineTo( buildingLength, 0 );

				/*var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var geometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				var mesh = new THREE.Mesh( geometry, new THREE.MeshPhongMaterial({color: 0xe8e8e8 ,wireframe: false, overdraw: true,transparent: true, opacity: 0.6}) );	
				mesh.position.set( 0, -300, levelY );
				scene.add(mesh);*/

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( -90, -300, levelY );
				scene.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
				}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: color, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( -90, -300, levelY );
				// #  Add to current scene
				scene.add(buildingMesh);
			}

			shape = buildingShape;
		} else if (floor_plan_type == 'TL-D') {
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(0, -700, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());
			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}

				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( buildingMiddlePoint, -buildingWidth );

				buildingShape.lineTo( buildingMiddlePoint, -buildingWidth * 2 );

				buildingShape.lineTo( buildingLength, -buildingWidth * 2 );
				buildingShape.lineTo( buildingLength, -buildingWidth );

				buildingShape.lineTo( buildingMiddlePoint, 0 );

				buildingShape.lineTo( buildingMiddlePoint, buildingHeight );
				buildingShape.lineTo( - buildingMiddlePoint, buildingHeight );

				buildingShape.lineTo( - buildingMiddlePoint, 0 );
				buildingShape.lineTo( 0, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( -30, -300, levelY );
				scene.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}
				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: color, wireframe: true, transparent: true, opacity: 0.1} );
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( -30, -300, levelY );
				// #  Add to current scene
				scene.add(buildingMesh);
			}

			shape = buildingShape;
		} else if (floor_plan_type == 'JOCO') {
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(0, -700, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());
			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}

				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, -buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint + 20, -buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint + 20, 0 );
				// #  Start the bottom section
				buildingShape.lineTo( -buildingLength, 0);
				buildingShape.lineTo( -buildingLength, - 10);
				buildingShape.lineTo( -buildingLength - 50, - 10);
				buildingShape.lineTo( -buildingLength - 50, buildingWidth );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( 0, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( 100, -300, levelY );
				scene.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}
				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: color, wireframe: true, transparent: true, opacity: 0.1} );
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( 100, -300, levelY );
				// #  Add to current scene
				scene.add(buildingMesh);
			}

			shape = buildingShape;
		}
		if(shape == null)
		{
			return null;
		}
		else
		{
			// #  Setup response
			response['scene'] = scene;
			response['camera'] = camera;
			return response;
		}
  	},
  	// #  The main use of this function is to pass a id to store our mini floor plan
  	create3DBuilding: function(context,floor_plan_type,total_levels, level_states) {
		/*
		Store data retrieved from reactjs context
		*/
		this.buildingData = {
			"buildingData": context.state.data.belongsTo,
			"buildingDetails": context.state.data.data,
			"buildingMetaData": context.state.data.meta_data,
			"buildingID": context.state.buildingID
		}
		var canvasID = context.state.canvasID;
		/*
		The purose of the continouse call is to handle cases
		where screen dimensions might change
		*/
		this.setUpWindowSize();
		activeLevelTempetureReadingsManager.clearAll();
  		// #  Setup our scene in which we will draw our canvas too.
		var scene = new THREE.Scene();
		// #  Setup canvas camera
		var camera = null;
		// #  Setup our Dom Events for listening when an object is clicked on in canvas
		this.domEvents = new THREEx.DomEvents(camera, context.state.renderer.domElement);
		// #  Setup array for storing all levels
		this.levelObjects = [];
		// #  Setup active hover array which stores the objects that we use to change data
		this.activeHoverObjects = [];
		// #  This holds one object that awaits to be pushed to activeHoverobject
		this.activeFloor = null;
		this.context = context;
		// #  Assign a routing object to our object
		//this.routingObj = routingObj;
		// #  Call building creation
		var buildingsObj = this.buildBuildingWireFrame(floor_plan_type,total_levels,canvasID, level_states);
		var buildings = null;
		var zoomOutLimit = 0;
		if(buildingsObj == null)
		{
			// #  Dont process
			return;
		}
		else
		{
			// #  Store our scene
			buildings = buildingsObj['scene'];
			// #  Store camera
			camera = buildingsObj['camera'];
			// #  Add buildings
			scene = buildings;
			// #  Store zoom out limit
			zoomOutLimit = buildingsObj['zoomOutLimit'];
		}
		// # Lights
		var ambientLight = new THREE.AmbientLight( 0x606060 );
		// #  Add to scene
		scene.add( ambientLight );
		// #  Setup directional lighting - use as sun.
		var directionalLight = new THREE.DirectionalLight( 0xffffff );
		directionalLight.position.x = -0.3146332814932844;//Math.random() - 0.5;
		directionalLight.position.y = 0.22805864947094354;//Math.random() - 0.5;
		directionalLight.position.z = -0.921409328462794;//Math.random() - 0.5;
		directionalLight.position.normalize();
		// #  Add to scene
		scene.add( directionalLight );
		var directionalLight = new THREE.DirectionalLight( 0x808080 );
		directionalLight.position.x = -0.04955394517284462;//Math.random() - 0.5;
		directionalLight.position.y = 0.6221458805093545;//Math.random() - 0.5;
		directionalLight.position.z = 0.7813314980743108;//Math.random() - 0.5;
		directionalLight.position.normalize();
		// #  Add to scene
		scene.add( directionalLight );
		// #  Setup our color for the background
		context.state.renderer.setClearColor( 0xFBFBFB );//0xf0f0f0
		// #  We need to dynamically set our width
		context.state.renderer.setSize( this.width, this.height );
		context.state.renderer.render( scene, camera );
		context.setState({
            updateCanvas: true
        });

		this.scene = scene;
		this.camera = camera;
		this.mouse = new THREE.Vector2();
		this.renderer = context.state.renderer;
		this.domEvents.camera(this.camera);
		this.raycaster = new THREE.Raycaster();
		this.context = context;
		this.initializeControls(zoomOutLimit,total_levels);
		activeSensorsManager.displayActiveSensorColorChange();
		activeLevelTempetureReadingsManager.displayAvgTempPerFloor();

		document.addEventListener('mousemove', this.onDocumentMouseMove.bind(this), false);
		window.addEventListener('resize', this.onWindowResize.bind(this), false);
		window.addEventListener('scroll', this.onWindowScroll.bind(this), true);
  	},
  	buildBuildingWireFrame: function(floor_plan_type,total_levels,canvasID, level_states) {
		var self = this;
  		// #  Setup our size and step
		var total_levels = parseInt(total_levels);
		// #  Setup THREE.shape object
		var shape = null;
		// #  Setup our scene in which we will draw our canvas too.
		var scene = new THREE.Scene();
		// #  Setup camera
		var camera = new THREE.PerspectiveCamera(40,this.width / this.height,1,10000);
		// #  Setup response
		var response = [];
  		// #  Determine our grid type and process accordingly
		if(floor_plan_type == "TR-L"){
			var group = new THREE.Object3D();
			// #  Use this to determine how low the building should be held on the y xis
			var yAxisLowered = (25 * parseInt(total_levels));
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			var rotation = (100 * parseInt(total_levels));
			var tilt = (70 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(rotation, tilt, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());

			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( buildingLength, buildingWidth );
				buildingShape.lineTo( buildingLength, 0 );
				// #  Start the bottom section
				buildingShape.lineTo( buildingMiddlePoint, 0);
				buildingShape.lineTo( buildingMiddlePoint, -buildingWidth );
				buildingShape.lineTo( 0, -buildingWidth );
				buildingShape.lineTo( 0, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set(0, 0, levelY );

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				group.add(buildingMesh);

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: color, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set(0, 0, levelY );

				// #  Lets assign a custom property for our mesh that tells us the level number
				buildingMesh.floorData = {
					floor_number: level + 1,
					building_name: this.buildingData.buildingDetails.building_name,
					building_data_id: this.buildingData.buildingDetails.building_data_id
				};
				group.add(buildingMesh);

				// #  Push the outer mesh layer to the levels object 
				this.levelObjects.push(buildingMesh);
				// #  Apply action listeners for when a level is hovered upon
				this.domEvents.addEventListener(buildingMesh, 'mouseover', this.mouseOverLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'mouseout', this.mouseOutLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'dblclick', this.moveLevelView.bind(this),false);
			}
			group.position.set(0,-yAxisLowered,0);
			//declared once at the top of your code
			var axis = new THREE.Vector3(1.13,0,0);//tilted a bit on x and y - feel free to plug your different axis here
			group.rotateOnAxis(axis,Math.pow(Math.PI, 2) / 2);
			scene.add( group );//when done, add the group to the scene

			shape = buildingShape;


		}
		else if(floor_plan_type == "BR-L"){
			var group = new THREE.Object3D();
			// #  Use this to determine how low the building should be held on the y xis
			var yAxisLowered = (25 * parseInt(total_levels));
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			var rotation = (100 * parseInt(total_levels));
			var tilt = (70 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(rotation, tilt, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());

			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( buildingLength, 0 );
				buildingShape.lineTo( buildingLength, buildingWidth );
				buildingShape.lineTo( buildingMiddlePoint, buildingWidth );
				// #  Start the top section
				buildingShape.lineTo( buildingMiddlePoint, 80);
				buildingShape.lineTo( 0, 80 );
				buildingShape.lineTo( 0, 0 );

				/*var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var geometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				var mesh = new THREE.Mesh( geometry, new THREE.MeshPhongMaterial({color: 0xe8e8e8 ,wireframe: false, overdraw: true,transparent: true, opacity: 0.6}) );	
				mesh.position.set( 0, -300, levelY );
				scene.add(mesh);*/


				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( -60, 0, levelY );
				group.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: 0x7F7F7F, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( -60, 0, levelY );
				// #  Lets assign a custom property for our mesh that tells us the level number
				buildingMesh.floorData = {
					floor_number: level + 1,
					building_name: this.buildingData.buildingDetails.building_name,
					building_data_id: this.buildingData.buildingDetails.building_data_id
				};
				// #  Add to current scene
				group.add(buildingMesh);
				// #  Push the outer mesh layer to the levels object 
				this.levelObjects.push(buildingMesh);
				// #  Apply action listeners for when a level is hovered upon
				this.domEvents.addEventListener(buildingMesh, 'mouseover', this.mouseOverLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'mouseout', this.mouseOutLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'dblclick', this.moveLevelView.bind(this),false);
			}

			group.position.set(0,-yAxisLowered,0);
			//declared once at the top of your code
			var axis = new THREE.Vector3(1.13,0,0);//tilted a bit on x and y - feel free to plug your different axis here
			group.rotateOnAxis(axis,Math.pow(Math.PI, 2) / 2);
			scene.add( group );//when done, add the group to the scene

			shape = buildingShape;
		}
		if(floor_plan_type == "TL-L"){
			var group = new THREE.Object3D();
			// #  Use this to determine how low the building should be held on the y xis
			var yAxisLowered = (25 * parseInt(total_levels));
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			var rotation = (-100 * parseInt(total_levels));
			var tilt = (70 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(rotation, tilt, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());

			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, -buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint, -buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint, 0 );
				// #  Start the bottom section
				buildingShape.lineTo( -buildingLength, 0);
				buildingShape.lineTo( -buildingLength, buildingWidth );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( 0, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( 60, 0, levelY );
				group.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: 0x7F7F7F, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( 60, 0, levelY );
				// #  Lets assign a custom property for our mesh that tells us the level number
				buildingMesh.floorData = {
					floor_number: level + 1,
					building_name: this.buildingData.buildingDetails.building_name,
					building_data_id: this.buildingData.buildingDetails.building_data_id
				};
				// #  Add to current scene
				group.add(buildingMesh);
				// #  Push the outer mesh layer to the levels object 
				this.levelObjects.push(buildingMesh);
				// #  Apply action listeners for when a level is hovered upon
				this.domEvents.addEventListener(buildingMesh, 'mouseover', this.mouseOverLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'mouseout', this.mouseOutLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'dblclick', this.moveLevelView.bind(this),false);
			}

			group.position.set(0, -yAxisLowered, 0);
			//declared once at the top of your code
			var axis = new THREE.Vector3(1.13,0,0);//tilted a bit on x and y - feel free to plug your different axis here
			group.rotateOnAxis(axis,Math.pow(Math.PI, 2) / 2);
			scene.add( group );//when done, add the group to the scene

			shape = buildingShape;

		}
		else if(floor_plan_type == "BL-L"){
			var group = new THREE.Object3D();
			// #  Use this to determine how low the building should be held on the y xis
			var yAxisLowered = (25 * parseInt(total_levels));
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			var rotation = (-100 * parseInt(total_levels));
			var tilt = (70 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(rotation, tilt, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3()); 

			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint, buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint, 0 );
				// #  Start the bottom section
				buildingShape.lineTo( -buildingLength, 0);
				buildingShape.lineTo( -buildingLength, -buildingWidth );
				buildingShape.lineTo( 0, -buildingWidth );
				buildingShape.lineTo( 0, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( 70, 0, levelY );

				group.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: 0x7F7F7F, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( 70, 0, levelY );
				// #  Lets assign a custom property for our mesh that tells us the level number
				buildingMesh.floorData = {
					floor_number: level + 1,
					building_name: this.buildingData.buildingDetails.building_name,
					building_data_id: this.buildingData.buildingDetails.building_data_id
				};
				// #  Add to current scene
				group.add(buildingMesh);
				// #  Push the outer mesh layer to the levels object 
				this.levelObjects.push(buildingMesh);
				// #  Apply action listeners for when a level is hovered upon
				this.domEvents.addEventListener(buildingMesh, 'mouseover', this.mouseOverLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'mouseout', this.mouseOutLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'dblclick', this.moveLevelView.bind(this),false);
			}

			group.position.set(0, -yAxisLowered, 0);
			//declared once at the top of your code
			var axis = new THREE.Vector3(1.13,0,0);//tilted a bit on x and y - feel free to plug your different axis here
			group.rotateOnAxis(axis,Math.pow(Math.PI, 2) / 2);
			scene.add( group );//when done, add the group to the scene

			shape = buildingShape;
		}
		else if(floor_plan_type == "Square"){
			var group = new THREE.Object3D();
			// #  Use this to determine how low the building should be held on the y xis
			var yAxisLowered = (25 * parseInt(total_levels));
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			var rotation = (100 * parseInt(total_levels));
			var tilt = (70 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(rotation, tilt, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());

			var buildingLength = 120, buildingWidth = 80, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( buildingLength, buildingWidth );
				buildingShape.lineTo( buildingLength, 0 );

				/*var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var geometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				var mesh = new THREE.Mesh( geometry, new THREE.MeshPhongMaterial({color: 0xe8e8e8 ,wireframe: false, overdraw: true,transparent: true, opacity: 0.6}) );	
				mesh.position.set( 0, -300, levelY );
				scene.add(mesh);*/

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( -60, 0, levelY );
				group.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: 0x7F7F7F, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( -60, 0, levelY );
				// #  Lets assign a custom property for our mesh that tells us the level number
				buildingMesh.floorData = {
					floor_number: level + 1,
					building_name: this.buildingData.buildingDetails.building_name,
					building_data_id: this.buildingData.buildingDetails.building_data_id
				};
				// #  Add to current scene
				group.add(buildingMesh);
				// #  Push the outer mesh layer to the levels object 
				this.levelObjects.push(buildingMesh);
				// #  Apply action listeners for when a level is hovered upon
				this.domEvents.addEventListener(buildingMesh, 'mouseover', this.mouseOverLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'mouseout', this.mouseOutLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'dblclick', this.moveLevelView.bind(this),false);
			}

			group.position.set(0,-yAxisLowered,0);
			//declared once at the top of your code
			var axis = new THREE.Vector3(1.13,0,0);//tilted a bit on x and y - feel free to plug your different axis here
			group.rotateOnAxis(axis,Math.pow(Math.PI, 2) / 2);
			scene.add( group );//when done, add the group to the scene

			shape = buildingShape;
		}
		else if(floor_plan_type == "Rectangle"){
			var group = new THREE.Object3D();
			// #  Use this to determine how low the building should be held on the y xis
			var yAxisLowered = (25 * parseInt(total_levels));
			// #  Prepare zoomin for camera
			var zoomIn = (100 * parseInt(total_levels));
			var rotation = (100 * parseInt(total_levels));
			var tilt = (70 * parseInt(total_levels));
			if(zoomIn < 300)
				zoomIn = 340;
			// #  Setup individual camera
			camera.position.set(rotation, tilt, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());

			var buildingLength = 180, buildingWidth = 50, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}
				// #  Create top right L section
				// #  Centralize building
				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( buildingLength, buildingWidth );
				buildingShape.lineTo( buildingLength, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( -60, 0, levelY );

				group.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: 0x7F7F7F, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( -60, 0, levelY );
				// #  Lets assign a custom property for our mesh that tells us the level number
				buildingMesh.floorData = {
					floor_number: level + 1,
					building_name: this.buildingData.buildingDetails.building_name,
					building_data_id: this.buildingData.buildingDetails.building_data_id
				};
				// #  Add to current scene
				group.add(buildingMesh);
				// #  Push the outer mesh layer to the levels object 
				this.levelObjects.push(buildingMesh);
				// #  Apply action listeners for when a level is hovered upon
				this.domEvents.addEventListener(buildingMesh, 'mouseover', this.mouseOverLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'mouseout', this.mouseOutLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'dblclick', this.moveLevelView.bind(this),false);
			}

			group.position.set(0,-yAxisLowered,0);
			//declared once at the top of your code
			var axis = new THREE.Vector3(1.13,0,0);//tilted a bit on x and y - feel free to plug your different axis here
			group.rotateOnAxis(axis,Math.pow(Math.PI, 2) / 2);
			scene.add( group );//when done, add the group to the scene
			shape = buildingShape;
		} else if (floor_plan_type == "TL-D"){
			var group = new THREE.Object3D();
			// #  Use this to determine how low the building should be held on the y xis
			var yAxisLowered = (25 * parseInt(total_levels));
			// #  Prepare zoomin for camera
			var zoomIn = (150 * parseInt(total_levels));
			var rotation = (1 * parseInt(total_levels));
			var tilt = (70 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(rotation, tilt, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());

			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}

				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( buildingMiddlePoint, -buildingWidth );

				buildingShape.lineTo( buildingMiddlePoint, -buildingWidth * 2 );

				buildingShape.lineTo( buildingLength, -buildingWidth * 2 );
				buildingShape.lineTo( buildingLength, -buildingWidth );

				buildingShape.lineTo( buildingMiddlePoint, 0 );

				buildingShape.lineTo( buildingMiddlePoint, buildingHeight );
				buildingShape.lineTo( - buildingMiddlePoint, buildingHeight );

				buildingShape.lineTo( - buildingMiddlePoint, 0 );
				buildingShape.lineTo( 0, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( -30, 0, levelY );
				group.add(buildingMesh);

				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: 0x7F7F7F, wireframe: true, transparent: true, opacity: 0.1} ); 
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( -30, 0, levelY );
				// #  Lets assign a custom property for our mesh that tells us the level number
				buildingMesh.floorData = {
					floor_number: level + 1,
					building_name: this.buildingData.buildingDetails.building_name,
					building_data_id: this.buildingData.buildingDetails.building_data_id
				};
				// #  Add to current scene
				group.add(buildingMesh);
				// #  Push the outer mesh layer to the levels object
				this.levelObjects.push(buildingMesh);
				// #  Apply action listeners for when a level is hovered upon
				this.domEvents.addEventListener(buildingMesh, 'mouseover', this.mouseOverLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'mouseout', this.mouseOutLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'dblclick', this.moveLevelView.bind(this),false);
			}

			group.position.set(0, -yAxisLowered, 0);
			//declared once at the top of your code
			var axis = new THREE.Vector3(1.13,0,0);//tilted a bit on x and y - feel free to plug your different axis here
			group.rotateOnAxis(axis,Math.pow(Math.PI, 2) / 2);
			scene.add( group );//when done, add the group to the scene

			shape = buildingShape;
		} else if (floor_plan_type == "JOCO"){
			var group = new THREE.Object3D();
			// #  Use this to determine how low the building should be held on the y xis
			var yAxisLowered = (25 * parseInt(total_levels));
			// #  Prepare zoomin for camera
			var zoomIn = (150 * parseInt(total_levels));
			var rotation = (1 * parseInt(total_levels));
			var tilt = (70 * parseInt(total_levels));
			// #  Setup individual camera
			camera.position.set(rotation, tilt, zoomIn);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3());

			var buildingLength = 140, buildingWidth = 40, buildingHeight = 50,buildingMiddlePoint = 70;
			for(var level = 0; level < total_levels; level++)
			{
				var color = 0x676767;
				// See if we have any active states to change the color
				if(level_states.levels_state_active == true) {
					for (var i = 0; i < level_states.levels_state.length; i++) {
						var level_state_data = level_states.levels_state[i];
						var actualLevel = level + 1;
						if(actualLevel == parseInt(level_state_data.level)) {
							color = level_state_data.color;
						}
						//Do something
					}
				}

				var buildingShape = new THREE.Shape();

				if(level == 0)
				{
					var levelY = 0;
				}
				else
				{
					levelY = (level * buildingHeight);
				}

				buildingShape.moveTo( 0, 0 );
				buildingShape.lineTo( 0, -buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint + 20, -buildingWidth );
				buildingShape.lineTo( -buildingMiddlePoint + 20, 0 );
				// #  Start the bottom section
				buildingShape.lineTo( -buildingLength, 0);
				buildingShape.lineTo( -buildingLength, - 10);
				buildingShape.lineTo( -buildingLength - 50, - 10);
				buildingShape.lineTo( -buildingLength - 50, buildingWidth );
				buildingShape.lineTo( 0, buildingWidth );
				buildingShape.lineTo( 0, 0 );

				var extrudeSettings = { amount: 50, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 1, bevelThickness: 1 };
				var buildingGeometry = new THREE.ExtrudeGeometry( buildingShape, extrudeSettings );
				// #  Setup building material
				var materialFront = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialSide = new THREE.MeshBasicMaterial({color: color ,wireframe: false, overdraw: false,transparent: true, opacity: 0.6});
				var materialArray = [ materialFront, materialSide ];
				var buildingMaterial = new THREE.MeshFaceMaterial(materialArray);
				// #  Process as a mesh
				var buildingMesh = new THREE.Mesh( buildingGeometry, buildingMaterial );
				// #  Add to current scene
				buildingMesh.position.set( 100, 0, levelY );
				group.add(buildingMesh);
				if(level_states.levels_state_active == true) {
					if(level_states.active_sensors.length > 0) {
						for (var i = 0; i < level_states.active_sensors.length; i++) {
							var sensor_data = level_states.active_sensors[i];
							var actualLevel = level + 1;
							if(actualLevel == parseInt(sensor_data.level)) {
								activeSensorsManager.setDataWithScene(buildingMesh, this, scene, camera, sensor_data);
							}
						}
					}
				}

				// #  Add Wireframe on top of that
				var wireframeTexture = new THREE.MeshBasicMaterial( { color: 0x7F7F7F, wireframe: true, transparent: true, opacity: 0.1} );
				var buildingMesh = new THREE.Mesh( buildingGeometry, wireframeTexture );
				buildingMesh.position.set( 100, 0, levelY );
				// #  Lets assign a custom property for our mesh that tells us the level number
				buildingMesh.floorData = {
					floor_number: level + 1,
					building_name: this.buildingData.buildingDetails.building_name,
					building_data_id: this.buildingData.buildingDetails.building_data_id
				};
				// #  Add to current scene
				group.add(buildingMesh);
				// Text rendering for displaying per-level feireinheit
				// create a canvas element
				var textCanvas = document.createElement('canvas');
				var textContext = textCanvas.getContext('2d');
				textContext.font = "Bold 20px Arial";
				textContext.fillStyle = "rgb(14, 71, 104)";
				textContext.fillText("", 0, 50);
				// canvas contents will be used for a texture
				var texture = new THREE.Texture(textCanvas)
				texture.needsUpdate = true;
				var textureMaterial = new THREE.MeshBasicMaterial( {map: texture, side:THREE.DoubleSide } );
				textureMaterial.transparent = true;
				var textureMesh = new THREE.Mesh(
					new THREE.PlaneBufferGeometry(100, 50),
					textureMaterial
				);
				textureMesh.position.set(-60,0,levelY);
				textureMesh.rotation.x = Math.PI / 2;
				activeLevelTempetureReadingsManager.setDataWithScene(textureMesh, this, scene, camera, level + 1);

				group.add(textureMesh);
				// #  Push the outer mesh layer to the levels object
				this.levelObjects.push(buildingMesh);
				// #  Apply action listeners for when a level is hovered upon
				this.domEvents.addEventListener(buildingMesh, 'mouseover', this.mouseOverLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'mouseout', this.mouseOutLevel.bind(this),false);
				this.domEvents.addEventListener(buildingMesh, 'dblclick', this.moveLevelView.bind(this),false);
			}

			group.position.set(0, -yAxisLowered, 0);
			//declared once at the top of your code
			var axis = new THREE.Vector3(1.13,0,0);//tilted a bit on x and y - feel free to plug your different axis here
			group.rotateOnAxis(axis,Math.pow(Math.PI, 2) / 2);
			scene.add( group );//when done, add the group to the scene

			shape = buildingShape;
		}
		if(shape == null)
		{
			return null;
		}
		else
		{
			var zoomOutLimit = zoomIn;
			// #  Setup response
			response['scene'] = scene;
			response['camera'] = camera;
			response['zoomOutLimit'] = zoomOutLimit;
			return response;
		}
  	},
  	// #  Function fires up the controls on operating the camera so you can swing it around
  	initializeControls: function(zoomOutLimit,total_levels) {
  		var controls;
		  // #  Controls are key to our rotation and zooming
		controls = new THREE.OrbitControls(this.camera,this.renderer.domElement);
		controls.addEventListener( 'change', this.render.bind(this),false );
		controls.enableZoom = true;
		// #  Disable pan (hold both mouse buttons and drag)
		if(total_levels >= 15)
		{
			controls.enablePan =true
		}
		else
		{
			controls.enablePan =false
		}
		controls.minDistance = 100;
		controls.maxDistance = (zoomOutLimit + 500);
		controls.maxPolarAngle = 1.5;
		// #  Store locally
		this.controls = controls;
  	},
  	render: function() {
	 	this.renderer.render( this.scene, this.camera );
	},
	mouseOverLevel: function(event){
		event.target.material.color.setHex(0x529487);
		event.target.material.opacity = 1;
		event.target.material.wireframe = false;
		this.activeFloor = event.target;
		// #  Lets see if this floor is already active
		if(this.activeHoverObjects.indexOf(this.activeFloor))
		{
			this.activeHoverObjects.push(this.activeFloor);
		}

		this.render();
	},
	mouseOutLevel: function(event){
		for(var i = 0; i < this.activeHoverObjects.length; i++)
		{
			this.activeHoverObjects[i].material.color.setHex(0x7F7F7F);
			this.activeHoverObjects[i].material.opacity = 0.1;
			this.activeHoverObjects[i].material.wireframe = true;
			this.activeHoverObjects.splice(i,1);
		}
		this.render();
	},
	moveLevelView: function(event){
		this.clearWindowTimeouts();
		var floorData = event.target.floorData;
		browserHistory.push('/building/' + this.buildingData.buildingID + '/level/' + floorData.floor_number);
	},
	displayActiveSensorColorChange: function(sensor_data) {
		var self = this;
		this.activeSensors.forEach(buildingLevel => {
			const startColor = buildingLevel.material.materials[0].color.getHex();
			const endColor = 0xF1C232;
			var didChange = false;
			var timeout = window.setInterval(function(){
				const colorToUse = didChange ? startColor : endColor;
				didChange = didChange ? false : true;
				buildingLevel.material.materials[0].color.setHex(colorToUse);
				// self.activeSensorUuid.push(sensor_data.sensor_uuid);
				self.render();
			}, 1000);

			self.activeWindowTimeout.push(timeout);
		});
	}
});

export let buildingRenderer = new buildingObject();


// WEBPACK FOOTER //
// app/core/graphic_engine/controllers/building.js